import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { FieldTranslatedResponse } from '../../models/response/field-translated-response-input.model';
import { AccountConfigurationResponse } from '../../models/response/account-configuration-response-input.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MessageDialogModalDialog } from '../errors-dialog/message-dialog-modal';

@Component({
  selector: 'project-visibility',
  templateUrl: './project-visibility.component.html',
  styleUrls: ['./project-visibility.component.scss']
})
export class ProjectVisibilityComponent implements OnInit, OnDestroy {

  constructor(
    private accountConfigurationService: AccountConfigurationService,
    private dialog: MatDialog) { }

  ngOnDestroy(): void {
  }

  locale: string;
  selectedOption: FieldTranslatedResponse = null;
  configurationsNameTranslated: FieldTranslatedResponse[];
  accountConfigurationResponse: AccountConfigurationResponse;
  configurationRequest = "ConfigurationProjectVisibility";


  ngOnInit(): void {
    let account = localStorage.getItem("acc");
    var cultureName = this.locale = localStorage.getItem("lang");

    this.accountConfigurationService.getEnumTranslations(cultureName, this.configurationRequest).subscribe({
      next: (data) => {
        this.configurationsNameTranslated = data;

        this.accountConfigurationService.getAccountConfigurations(account).subscribe({
          next: (data) => {
            data.ConfigurationItems.forEach(element => {

              const selectedValue = element.Value;

              const selectedOption = this.configurationsNameTranslated.find(option => option.Value === selectedValue);

              if (selectedOption) {
                this.selectedOption = selectedOption;
              }
            });
          }
        });
      }
    });
  }

  onSaveClick() {
    const account = localStorage.getItem("acc");

    this.accountConfigurationService.patchAccountConfigurations(account, [{ Type: 0, Value: this.selectedOption.Value }]).subscribe({
      next: () => {
        this.dialog.open(MessageDialogModalDialog, {
          data: {
            title: "",
            message: "visibilityRequest.success.configurationRegisteredSuccessfully",
            isError: false
          }
        }).afterClosed().subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        if (error.status == 400) {
          this.dialog.open(MessageDialogModalDialog, {
            data: {
              title: "visibility.messages.alertTitle",
              message: "visibilityRequest.errors.userIsNotAnAccountAdministrator",
              isError: true
            }
          });
        }
        if (error.status == 500) {
          this.dialog.open(MessageDialogModalDialog, {
            data: {
              title: "visibility.messages.alertTitle",
              message: "visibilityRequest.errors.internalServerError",
              isError: true
            }
          });
        }
      }
    });
  }

  onCancelClick() {
    window.location.reload();
  }
}
